const createHash = (data: any) => {
  const toStableValue = (obj: any): any => {
    
    if (obj === undefined || obj === null || obj === void 0) return "";

    if (Array.isArray(obj)) return obj.map(toStableValue);

    if (typeof obj === "object")
      return Object.keys(obj)
        .sort()
        .map(key => [key, toStableValue(obj[key])]);
    return obj;
  };

  return String(toStableValue(data));
};

export default createHash;
